import { get } from "lodash";
import {
  GROUP_KEYS,
  modifyDataOfAddIssue,
  getLocalstorage
} from "../../helper";
import moment from "moment";
import htmlToFormattedText from "html-to-formatted-text";
import { underMaintenance } from "../../services/apiServices";

export function modifyDataForPost(data, _status) {
  const locations = [];
  const pragati = {};
  const nip = {};
  const pmFoundationStone = {};
  const pmGatiShakti = {};
  const PmgsHip = {};

  const cmPragatiYatra = {};
  const cmFoundationStone = {};
  let status = {};
  const pli = {};

  data.hasOwnProperty("pragatiReview") &&
    (pragati["pragatiReview"] = get(data, "pragatiReview"));
  data.hasOwnProperty("pragatiPipeline") &&
    (pragati["pragatiPipeline"] = get(data, "pragatiPipeline"));
  data.hasOwnProperty("pragatiCycleDate") &&
    (pragati["pragatiCycleDate"] = get(data, "pragatiCycleDate"));
  data.hasOwnProperty("nipReview") &&
    (nip["nipReview"] = get(data, "nipReview"));
  data.hasOwnProperty("nipReviewDate") &&
    (nip["nipReviewDate"] = get(data, "nipReviewDate"));

  data.hasOwnProperty("pmFoundationStone") &&
    (pmFoundationStone["pmFoundationStone"] = get(data, "pmFoundationStone"));
  data.hasOwnProperty("pmFoundationStoneDate") &&
    (pmFoundationStone["pmFoundationStoneDate"] = get(
      data,
      "pmFoundationStoneDate"
    ));
  data.hasOwnProperty("pmFoundationStoneId") &&
    (pmFoundationStone["pmFoundationStoneId"] = get(data, "pmFoundationStoneId")
      ? "FS-" + get(data, "pmFoundationStoneId").replace("FS-", "")
      : null);

  data.hasOwnProperty("pmGatiShakti") &&
    (pmGatiShakti["pmGatiShakti"] = get(data, "pmGatiShakti"));
  data.hasOwnProperty("pmgsHip") && (PmgsHip["pmgsHip"] = get(data, "pmgsHip"));
  data.hasOwnProperty("pmgsHipDate") &&
    (PmgsHip["pmgsHipDate"] = get(data, "pmgsHipDate"));

  data.hasOwnProperty("cmPragatiYatra") &&
    (cmPragatiYatra["cmPragatiYatra"] = get(data, "cmPragatiYatra"));
  data.hasOwnProperty("cmPragatiYatraDate") &&
    (cmPragatiYatra["cmPragatiYatraDate"] = get(data, "cmPragatiYatraDate"));
  data.hasOwnProperty("cmFoundationStone") &&
    (cmFoundationStone["cmFoundationStone"] = get(data, "cmFoundationStone"));
  data.hasOwnProperty("cmFoundationStoneDate") &&
    (cmFoundationStone["cmFoundationStoneDate"] = get(
      data,
      "cmFoundationStoneDate"
    ));

  pli["pli"] = get(data, "pli");
  const pragatiPipeline = get(data, "pragatiPipeline");

  if (pragatiPipeline) {
    pragati["pragatiPipeline"] = pragatiPipeline;
    pragati["pragatiCycleDate"] = get(data, "pragatiCycleDate");
  } else {
    pragati["pragatiPipeline"] = pragatiPipeline; // will be false or undefined
    pragati["pragatiCycleDate"] = null;
  }
  if (
    data.hasOwnProperty("projectCompletionDTO") &&
    data.projectCompletionDTO &&
    data.projectCompletionDTO.status
  ) {
    let statusKey = data.projectCompletionDTO.status;

    if (
      statusKey === "UNDER CONSTRUCTION" ||
      statusKey === "PROVISIONALLY COMMISSIONED" ||
      statusKey === "COMMISSIONED" ||
      statusKey === "UNDER DEVELOPMENT" ||
      statusKey === "PHYSICALLY COMPLETED/CC UNDER ISSUE"
    ) {
      if (statusKey === "UNDER CONSTRUCTION") {
        statusKey = "underConstruction";
      }

      if (statusKey === "PROVISIONALLY COMMISSIONED") {
        statusKey = "provisionallyCommissioned";
      }

      if (statusKey === "COMMISSIONED") {
        statusKey = "commissioned";
      }

      if (statusKey === "UNDER DEVELOPMENT") {
        statusKey = "noImplementation";
      }
      if (statusKey === "PHYSICALLY COMPLETED/CC UNDER ISSUE") {
        statusKey = "projectPhysicallyCompleted";
      }
    }
    status = {
      [statusKey]: {
        date: data.projectCompletionDTO.date,
        percentage: data.projectCompletionDTO.percentage,
        physicalProgressAsOf: data.projectCompletionDTO.physicalProgressAsOf,
        financialPercentage: data.projectCompletionDTO.financialPercentage
      }
    };
  }
  if (data.projectCompletionDTO.status === null) {
    status = {
      noImplementation: {
        date: data.projectCompletionDTO.date,
        percentage: data.projectCompletionDTO.percentage,
        physicalProgressAsOf: data.projectCompletionDTO.physicalProgressAsOf,
        financialPercentage: data.projectCompletionDTO.financialPercentage
      }
    };
  }

  get(data, "locations", []).forEach(value => {
    value.id &&
      locations.push({
        stateId: +value.id,
        cost: +(value.cost || 0),
        distance: +(value.distance || 0),
        districtId: value.districtId || [],
        circleId: value.circleId || []
      });
  });

  const isProjectAwardedByState =
    data.hasOwnProperty("projectCategoryId") &&
    data.projectCategoryId === GROUP_KEYS.STATE;
  const issues = modifyDataOfAddIssue(data, isProjectAwardedByState, _status);

  const banks = [];
  get(data, "projectBankInfoBanks", []).forEach(value => {
    let otherBank = get(data, "otherBankName", null);
    if (value.id === 51 && (otherBank === null || otherBank === "")) {
      banks.push();
    } else {
      banks.push(value.id);
    }
  });
  return {
    projectCategoryId: get(data, "projectCategoryId"),
    name: htmlToFormattedText(get(data, "name", "")),
    cost: get(data, "cost", 0) || 0,
    revisedCost: get(data, "revisedCost", null) || null,
    stateCost: get(data, "stateCost", null) || null,
    stateWiseData: get(data, "stateWiseData", null),
    centralCost: get(data, "centralCost", null) || null,
    geoCoordinates: get(data, "geoCoordinates", ""),
    projectExtensionFiles: get(data, "projectExtensionFiles", []).map(value => {
      return value.id;
    }),
    populationBenefitted: get(data, "populationBenefitted", ""),
    description: htmlToFormattedText(get(data, "description", "")),
    groupId: (get(data, "groupId") && +get(data, "groupId")) || "", // where it should come from
    district: get(data, "district") && +get(data, "district"),
    sponsoringDepartmentId:
      get(data, "projectCategoryId") === "CENTRAL" ||
      get(data, "projectCategoryId") === "STATE"
        ? get(data, "sponsoringDepartmentId")
          ? +get(data, "sponsoringDepartmentId")
          : null
        : null,
    divisionId: (get(data, "divisionId") && +get(data, "divisionId")) || null,
    cinId: get(data, "cinInfo.id"),
    fundReleaseCost: get(data, "fundReleaseCost", null) || null,
    schemeForAr: get(data, "schemeForAr"),
    executingAgency: get(data, "executingAgency"),
    sponsoringAgency: get(data, "sponsoringAgency"),
    sectorId: +get(data, "sectorId", "0"),
    subSectorId: +get(data, "subSectorId") || null,
    schemeId: +get(data, "schemeId", null),
    fdi: +get(data, "fdi", 0),
    implementationMode:
      get(data, "implementationMode") && get(data, "implementationMode") !== ""
        ? get(data, "implementationMode")
        : null,
    issueCOS: issues,
    locations: locations,
    updatedCreatedById: get(data, "userID.id")
      ? get(data, "userID.id")
      : get(data, "userID"),
    pli:
      get(data, "implementationMode") === "PRIVATE" ? get(data, "pli") : false,
    portConnectivity: get(data, "portConnectivity", false),
    coalConnectivity: get(data, "coalConnectivity", false),
    esamiksha: get(data, "esamiksha", false),
    march24: get(data, "march24", false),
    ...pragati,
    ...nip,
    ...pmFoundationStone,
    ...PmgsHip,
    ...cmPragatiYatra,
    ...cmFoundationStone,
    pmGatiShaktiNew: get(data, "pmGatiShakti"),
    projectBankInfo: {
      banks: banks,
      actualDate: get(data, "projectBankInfoActualDate", ""),
      expectedDate: get(data, "projectBankInfoExpectedDate", ""),
      otherBankName: get(data, "otherBankName", null)
    },
    projectImplementation: {
      classification: get(data, "projectImplementationClassification", null),
      startState: get(data, "projectImplementationStartState", ""),
      startDate: get(data, "projectImplementationStartDate", null) || null,
      projectSanctionDate:
        get(data, "projectImplementationSanctionDate", null) || null,
      secretaryReviewDates:
        get(data, "projectImplementationSecretaryReviewDate", null) || [],
      anticipatedDateOfCompletion: get(
        data,
        "projectImplementationAnticipatedDate"
      )
        ? moment(get(data, "projectImplementationAnticipatedDate")).valueOf()
        : null,
      directEmployment: get(
        data,
        "projectImplementationDirectEmployment",
        null
      ),
      indirectEmployment: get(
        data,
        "projectImplementationInDirectEmployment",
        null
      ),
      // targetCompletionDate: +get(data, "targetCompletionDate", 0),
      revisedTargetCompletionDate: get(data, "revisedTargetCompletionDate")
        ? moment(get(data, "revisedTargetCompletionDate")).valueOf()
        : null
    },
    mapImageFiles: get(data, "mapImageFiles", []).map(value => {
      return value.id;
    }),
    files: get(data, "files", []).map(value => {
      return value.id;
    }),
    //bucketMilestoneCOS: get(data, "bucketMilestoneCOS", []),
    bucketMilestoneCOS: get(data, "isEdit")
      ? []
      : setOutgoingDataForMilestone(get(data, "bucketMilestoneCOS", [])) || [],
    ...status
  };
}

export function modifyDataForEdit(data) {
  const userInfo = getLocalstorage("user");
  const isStatePMG = userInfo.groupCategory === "STATE_PMG";
  const isStateDepartment = userInfo.groupCategory === "STATE_DEPARTMENT";
  const pragati = {};
  const nip = {};
  const pmFoundationStone = {};
  const pmGatiShakti = {};
  const pli = {};
  const pmgsHip = {};
  const cmPragatiYatra = {};
  const cmFoundationStone = {};
  if (get(data, "pliDTO")) {
    pli["pli"] = get(data, "pilDTO.pli");
  }
  if (get(data, "pragatiDTO")) {
    pragati["pragatiReview"] = get(data, "pragatiDTO.pragatiReview");
    //pragati["pragatiReviewDate"] = get(data, "pragatiDTO.pragatiReviewDate");
    pragati["pragatiReviewDates"] = get(data, "pragatiDTO.pragatiReviewDates");
    pragati["pragatiPipeline"] = get(data, "pragatiDTO.pragatiPipeline");
    pragati["pragatiCycleDate"] = get(data, "pragatiDTO.pragatiCycleDate");
  }
  if (get(data, "nipDTO")) {
    nip["nipReview"] = get(data, "nipDTO.nipReview");
    nip["nipReviewDate"] = get(data, "nipDTO.nipReviewDate");
  }
  if (get(data, "pmFoundationStoneDTO")) {
    pmFoundationStone["pmFoundationStone"] = get(
      data,
      "pmFoundationStoneDTO.pmFoundationStone"
    );
    pmFoundationStone["pmFoundationStoneId"] = get(
      data,
      "pmFoundationStoneDTO.pmFoundationStoneId"
    );
    pmFoundationStone["pmFoundationStoneDate"] = get(
      data,
      "pmFoundationStoneDTO.pmFoundationStoneDate"
    );
  }
  if (get(data, "pmGatiShaktiNewDTO")) {
    pmGatiShakti["pmGatiShakti"] = get(
      data,
      "pmGatiShaktiNewDTO.pmGatiShaktiNew"
    );
    // pmGatiShakti["pmGatiShaktiDate"] = get(
    //   data,
    //   "pmGatiShaktiDTO.pmGatiShaktiDate"
    // );
  }

  if (get(data, "cmFoundationStoneDTO")) {
    cmFoundationStone["cmFoundationStoneDate"] = get(
      data,
      "cmFoundationStoneDTO.cmFoundationStoneDate"
    );
    cmFoundationStone["cmFoundationStone"] = get(
      data,
      "cmFoundationStoneDTO.cmFoundationStone"
    );
  }
  if (get(data, "cmPragatiYatraDTO")) {
    cmPragatiYatra["cmPragatiYatra"] = get(
      data,
      "cmPragatiYatraDTO.cmPragatiYatra"
    );
    cmPragatiYatra["cmPragatiYatraDate"] = get(
      data,
      "cmPragatiYatraDTO.cmPragatiYatraDate"
    );
  }
  if (get(data, "pmGsHipDTO")) {
    pmgsHip["pmgsHip"] = get(data, "pmGsHipDTO.pmgsHip");
    pmgsHip["pmgsHipDate"] = get(data, "pmGsHipDTO.pmgsHipDate");
  }

  return {
    projectCategoryId: get(data, "projectCategory"), // removed after discussion with shobhit
    groupId: get(data, "sponsoredBy.id"),
    district: get(data, "district") && +get(data, "district"),
    name: htmlToFormattedText(get(data, "name")),
    cost: get(data, "cost"),
    revisedCost: get(data, "revisedCost"),
    description: htmlToFormattedText(get(data, "description")),
    edit: get(data, "edit"),
    id: get(data, "id"),
    cin: get(data, "cin.number"),
    cinInfo: get(data, "cin"),
    sectorId: get(data, "sector.id"),
    subSectorId: get(data, "subSector.id"),
    status: get(data, "status"),
    schemeId: get(data, "scheme.id"),
    projectCreatedFrom: get(data, "projectCreatedFrom", ""),
    fdi: get(data, "fdi", 0),
    implementationMode: get(data, "implMode"),
    fundReleaseCost: get(data, "fundReleaseCost"),
    schemeForAr: get(data, "schemeForAr"),
    executingAgency: get(data, "executingAgency"),
    sponsoringAgency: get(data, "sponsoringAgencyId"),
    issues: get(data, "issues"),
    displayAutocomplete: get(data, "displayAutocomplete"),
    userID:
      isStatePMG || isStateDepartment
        ? get(data, "statePreviousCreatedBy")
        : get(data, "previousCreatedBy"),
    defaultSelected:
      isStatePMG || isStateDepartment
        ? `${get(data, "statePreviousCreatedBy.name")} (${get(
            data,
            "statePreviousCreatedBy.organization"
          )})`
        : get(data, "previousCreatedBy.name"),
    revisedTargetCompletionDate: get(data, "revisedTargetCompletionDate"),
    locations: get(data, "locations", []).map(value => {
      return {
        id: value.stateId,
        name: value.state,
        distance: value.distance,
        cost: value.cost,
        districtId: value.districtId || [],
        districtList: value.districtList,
        districtIdName: value.districtIdName || [],
        circleId: value.circleId || [],
        circleList: value.circleList,
        circleIdName: value.circleIdName || []
      };
    }),
    projectBankInfoBanks: get(data, "banks", []),
    groupCategoryList: [],
    costAndDistance: {
      distance:
        (get(data, "locations", []).find(value => value.distance) && true) ||
        false,
      cost:
        (get(data, "locations", []).find(value => value.cost) && true) || false
    },
    schemesList: [],
    subSectorList: [],
    // targetCompletionDate: get(data, "targetCompletionDate"),
    projectBankInfoActualDate: get(data, "finClosureDate"),
    projectBankInfoExpectedDate: get(data, "finClosureExpDate"),
    projectImplementationClassification: get(data, "classfication"),
    projectImplementationStartState: get(data, "implementationStarted"),
    projectImplementationStartDate: get(data, "implementationStartDate"),
    projectImplementationSanctionDate: get(data, "projectSanctionDate"),
    projectImplementationSecretaryReviewDate: get(data, "secretaryReviewDates"),
    projectImplementationAnticipatedDate: get(
      data,
      "anticipatedDateOfCompletion"
    ),
    projectImplementationDirectEmployment: get(data, "directEmpGeneration"),
    projectImplementationInDirectEmployment: get(data, "indirectEmpGeneration"),
    projectId: get(data, "projectId"),
    issueCOList: get(data, "issueCOList"),
    mapImageFiles: get(data, "mapImageFiles", []),
    files: get(data, "documents", []),
    projectExtensionFiles: get(data, "projectExtensionFiles", []),
    projectCompletionDTO: get(data, "projectCompletionDTO", {}),
    sponsoredBy: get(data, "sponsoredBy", {}),
    sponsoringDepartmentId: get(data, "sponsoringDepartment.id", null),
    divisionId: get(data, "division.id", null),
    otherBankName: get(data, "otherBankName", null),
    formType: get(data, "formType", null),
    showOtherPP: get(data, "showOtherPP", null),
    otherPP:
      isStatePMG || isStateDepartment
        ? get(data, "stateOtherPP", null)
        : get(data, "otherPP", null),
    editSector: get(data, "editSector", false),
    pli: get(data, "pliDTO.pli", false),
    march24: get(data, "march24DTO.march24", false),
    portConnectivity: get(data, "portConnectivityDTO.portConnectivity", false),
    portConnectivityDTO: data["portConnectivityDTO"],
    coalConnectivity: get(data, "coalConnectivityDTO.coalConnectivity", false),
    coalConnectivityDTO: data["coalConnectivityDTO"],
    esamiksha: get(data, "esamikshaDTO.esamiksha", false),
    esamikshaDTO: data["coalConnectivityDTO"],
    // PmgsHip: data["pmgship"],

    ...pragati,
    ...nip,
    ...pmFoundationStone,
    ...pmgsHip,
    ...pmGatiShakti,
    ...cmPragatiYatra,
    ...cmFoundationStone,
    stateCost: get(data, "stateCost"),
    centralCost: get(data, "centralCost"),
    populationBenefitted: get(data, "populationBenefitted", ""),
    geoCoordinates: get(data, "geoCoordinates", ""),
    error: {
      projectCategoryId: { error: false },
      name: { error: false },
      groupId: { error: false },
      cost: { error: false },
      centralCost: { error: false },
      stateCost: { error: false },
      description: { error: false },
      cin: { error: false },
      fundReleaseCost: { error: false },
      implementationMode: { error: false },
      locations: get(data, "locations", []).map(() => {
        return { error: false };
      }),
      projectImplementationClassification: { error: false },
      projectImplementationSanctionDate: { error: false },
      sectorId: { error: false },
      subSectorId: { error: false },
      schemeId: { error: false },
      projectImplementationStartState: { error: false },
      projectCompletionDTO: { error: false },
      revisedCost: { error: false },
      otherBankName: { error: false }
    },
    isApiLoading: false,
    districtList: [],
    circleList: [],
    divisionList: get(data, "divisionList")
  };
}

export function modifyDataForDraftProject(data) {
  const userInfo = getLocalstorage("user");
  const isStatePMG = userInfo.groupCategory === "STATE_PMG";
  const isStateDepartment = userInfo.groupCategory === "STATE_DEPARTMENT";
  const pragati = {};
  const nip = {};
  const pmFoundationStone = {};
  const PmgsHip = {};
  const pli = {};
  const cmPragatiYatra = {};
  const cmFoundationStone = {};
  if (get(data, "pliDTO")) {
    pli["pli"] = get(data, "pliDTO.pli");
  }
  if (get(data, "pragatiDTO")) {
    pragati["pragatiReview"] = get(data, "pragatiDTO.pragatiReview");
    //pragati["pragatiReviewDate"] = get(data, "pragatiDTO.pragatiReviewDate");
    pragati["pragatiReviewDates"] = get(data, "pragatiDTO.pragatiReviewDates");
    pragati["pragatiPipeline"] = get(data, "pragatiDTO.pragatiPipeline");
    pragati["pragatiCycleDate"] = get(data, "pragatiDTO.pragatiCycleDate");
  }
  if (get(data, "nipDTO")) {
    nip["nipReview"] = get(data, "nipDTO.nipReview");
    nip["nipReviewDate"] = get(data, "nipDTO.nipReviewDate");
  }
  if (get(data, "pmFoundationStoneDTO")) {
    pmFoundationStone["pmFoundationStone"] = get(
      data,
      "pmFoundationStoneDTO.pmFoundationStone"
    );
    pmFoundationStone["pmFoundationStoneId"] = get(
      data,
      "pmFoundationStoneDTO.pmFoundationStoneId"
    );
    pmFoundationStone["pmFoundationStoneDate"] = get(
      data,
      "pmFoundationStoneDTO.pmFoundationStoneDate"
    );
  }
  if (get(data, "pmGsHipDTO")) {
    PmgsHip["pmgsHip"] = get(data, "pmGsHipDTO.pmgsHip");
    PmgsHip["pmgsHipDate"] = get(data, "pmGsHipDTO.pmgsHipDate");
  }
  if (get(data, "cmFoundationStoneDTO")) {
    cmFoundationStone["cmFoundationStoneDate"] = get(
      data,
      "cmFoundationStoneDTO.cmFoundationStoneDate"
    );
    cmFoundationStone["cmFoundationStone"] = get(
      data,
      "cmFoundationStoneDTO.cmFoundationStone"
    );
  }
  if (get(data, "cmPragatiYatraDTO")) {
    cmPragatiYatra["cmPragatiYatra"] = get(
      data,
      "cmPragatiYatraDTO.cmPragatiYatra"
    );
    cmPragatiYatra["cmPragatiYatraDate"] = get(
      data,
      "cmPragatiYatraDTO.cmPragatiYatraDate"
    );
  }
  return {
    projectCategoryId: get(data, "projectCategory"), // removed after discussion with shobhit
    groupId: get(data, "sponsoredBy.id"),
    district: get(data, "district") && +get(data, "district"),
    name: htmlToFormattedText(get(data, "name")),
    projectNameTitle: htmlToFormattedText(
      get(data, "projectNameTitle", "Project Name")
    ),
    cost: get(data, "cost"),
    revisedCost: get(data, "revisedCost"),
    description: htmlToFormattedText(get(data, "description")),
    edit: get(data, "edit"),
    id: get(data, "id"),
    cin: htmlToFormattedText(get(data, "cin.number")),
    cinInfo: htmlToFormattedText(get(data, "cin")),
    sectorId: get(data, "sector.id"),
    subSectorId: get(data, "subSector.id"),
    status: get(data, "status"),
    schemeId: get(data, "scheme.id"),
    fdi: get(data, "fdi", 0),
    implementationMode: get(data, "implMode"),
    issues: get(data, "issues"),
    displayAutocomplete: get(data, "displayAutocomplete"),
    userID:
      isStatePMG || isStateDepartment
        ? get(data, "statePreviousCreatedBy")
        : get(data, "previousCreatedBy"),
    createdBy: get(data, "previousCreatedBy"),
    defaultSelected:
      isStatePMG || isStateDepartment
        ? `${get(data, "statePreviousCreatedBy.name")} (${get(
            data,
            "statePreviousCreatedBy.organization"
          )})`
        : `${get(data, "previousCreatedBy.name")} (${get(
            data,
            "previousCreatedBy.userID"
          )})`,
    revisedTargetCompletionDate: get(data, "revisedTargetCompletionDate"),
    stateCost: get(data, "stateCost", null) || null,
    fundReleaseCost: get(data, "fundReleaseCost", null) || null,
    schemeForAr: get(data, "schemeForAr"),
    executingAgency: get(data, "executingAgency"),
    sponsoringAgency: get(data, "sponsoringAgencyId"),
    centralCost: get(data, "centralCost", null) || null,
    populationBenefitted: get(data, "populationBenefitted", ""),
    geoCoordinates: get(data, "geoCoordinates", ""),
    projectExtensionFiles: get(data, "projectExtensionFiles", []),
    locations: get(data, "locations", []).map(value => {
      return {
        id: value.stateId,
        name: value.state,
        distance: value.distance,
        cost: value.cost,
        districtId: value.districtId || [],
        districtList: value.districtList,
        districtIdName: value.districtIdName || [],
        circleId: value.circleId || [],
        circleList: value.circleList,
        circleIdName: value.circleIdName || []
      };
    }),
    projectBankInfoBanks: get(data, "banks", []),
    groupCategoryList: [],
    costAndDistance: {
      distance:
        (get(data, "locations", []).find(value => value.distance) && true) ||
        false,
      cost:
        (get(data, "locations", []).find(value => value.cost) && true) || false
    },
    schemesList: [],
    subSectorList: [],
    // targetCompletionDate: get(data, "targetCompletionDate"),
    projectBankInfoActualDate: get(data, "finClosureDate"),
    projectBankInfoExpectedDate: get(data, "finClosureExpDate"),
    projectImplementationClassification: get(data, "classfication"),
    projectImplementationStartState: get(data, "implementationStarted"),
    projectImplementationStartDate: get(data, "implementationStartDate"),
    projectImplementationSanctionDate: get(data, "projectSanctionDate"),
    projectImplementationSecretaryReviewDate: get(data, "secretaryReviewDates"),
    projectImplementationAnticipatedDate: get(
      data,
      "anticipatedDateOfCompletion"
    ),
    projectImplementationDirectEmployment: get(data, "directEmpGeneration"),
    projectImplementationInDirectEmployment: get(data, "indirectEmpGeneration"),
    projectId: get(data, "projectId"),
    issueCOList: get(data, "issueCOList"),
    mapImageFiles: get(data, "mapImageFiles", []),
    files: get(data, "documents", []),
    projectCompletionDTO: get(data, "projectCompletionDTO", {}),
    sponsoredBy: get(data, "sponsoredBy", {}),
    sponsoringDepartmentId: get(data, "sponsoringDepartment.id", null),
    divisionId: get(data, "division.id", null),
    otherBankName: get(data, "otherBankName", null),
    bucketMilestoneCOS: setDraftDataForMilestone(
      get(data, "bucketDataList", [])
    ),
    ...pragati,
    ...nip,
    ...pmFoundationStone,
    ...PmgsHip,
    ...pli,
    ...cmPragatiYatra,
    ...cmFoundationStone,
    error: {
      projectCategoryId: { error: !get(data, "projectCategory") },
      name: { error: !get(data, "name") },
      groupId: { error: !get(data, "sponsoredBy.id") },
      cost: {
        error:
          get(data, "sponsoredBy.id") !== 226 &&
          !get(data, "superAdmin") &&
          !get(data, "cost")
      },
      description: { error: !get(data, "description") },
      implementationMode: { error: !get(data, "implMode") },
      locations: [
        { error: !(get(data, "locations") && get(data, "locations").length) }
      ],
      projectImplementationClassification: {
        error: !get(data, "classfication")
      },
      sectorId: { error: !get(data, "sector.id") },
      subSectorId: { error: !get(data, "subSector.id") },
      projectImplementationStartState: {
        error: !get(data, "implementationStarted")
      },
      projectCompletionDTO: {
        error:
          get(data, "implementationStarted") !== "COMPLETED" &&
          !get(data, "projectCompletionDTO")
      },
      otherBankName: { error: !get(data, "otherBankName") },
      projectImplementationAnticipatedDate: {
        error: !get(data, "anticipatedDateOfCompletion")
      },
      projectImplementationSanctionDate: {
        error: !get(data, "pli") && !get(data, "projectSanctionDate")
      },
      projectImplementationSecretaryReviewDate: {
        error: !get(data, "secretaryReviewDates")
      },
      projectImplementationStartDate: {
        error: !get(data, "pli") && !get(data, "implementationStartDate")
      }
    },
    isApiLoading: false,
    districtList: [],
    circleList: []
  };
}

export function modifyMilestoneData(key) {}

export const defaultState = () => ({
  projectCategoryId: null,
  name: "",
  cost: "",
  fundReleaseCost: null,
  executingAgency: "",
  description: "",
  schemeForAr: "",
  centralProjectShare: "",
  stateProjectShare: "",
  sponsoringAgencyList: [],
  sponsoringAgency: "",
  groupId: "",
  cin: "",
  sectorId: "",
  subSectorId: "",
  schemeId: "",
  fdi: "",
  districtErrormessage: false,
  stateErrormessage: false,
  implementationMode: null,
  issues: [],
  locations: [],
  projectBankInfoBanks: [],
  groupCategoryList: [],
  costAndDistance: {},
  schemesList: [],
  arSchemesList: [],
  subSectorList: [],
  projectBankInfoActualDate: "",
  projectBankInfoExpectedDate: "",
  projectImplementationClassification: null,
  projectImplementationStartState: null,
  projectImplementationStartDate: "",
  projectImplementationSanctionDate: "",
  projectImplementationSecretaryReviewDate: "",
  projectImplementationAnticipatedDate: "",
  projectImplementationDirectEmployment: "",
  projectImplementationInDirectEmployment: "",
  issueCOList: [{}],
  mapImageFiles: [],
  projectExtensionFiles: [],
  geoCordinateError: "",
  projectExtensionFilesErr: "",
  sponsoringDeptARdata: [],
  files: [],
  error: {},
  cinInfo: null,
  isApiLoading: false,
  displayAutocomplete: false,
  districtList: [],
  circleList: [],
  projectCompletionDTO: {},
  selectedOptionImageUrl: "",
  isOtherSelected: false,
  dataUnsaved: false,
  previewClicked: false,
  isConfirmModalVisible: false,
  stateMinimumCost: 0.01,
  stateMinimumCostAP: 50,
  projectCosterror: false,
  projectrevisedCosterror: false,
  projectNameTitle: "Project Name",
  bucketMilestoneCOS: [],
  milestoneDataCOS: [],
  milestoneTableDataCOS: [],
  pli: false,
  iigPayload: null,
  iigProjectStatus: "",
  iigMappingdetails: {},
  addAttachmentFile: [],
  implMode: "",
  iigProjectReferenceId: null,
  portConnectivity: false,
  coalConnectivity: false,
  userCanCreateCentralProject: false,
  userCanCreateStateProject: false,
  userGroupInfo: null,
  defaultCentralSelected: false,
  defaultStateSelected: false,
  handleMouseOut: false,
  esamiksha: false,
  sponsoringDepartmentId: null,
  divisionId: null,
  geoCoordinates: "",
  centralCost: null,
  stateCost: null,
  populationBenefitted: "",
  march24: false,
  showPhaseOnBucketComplete: false,
  projectstageerror: "",
  revisedtargetfielddisplay: false,
  defaultSelected: "",
  pmFoundationStoneId: "",
  displayBendept: true,
  projectCreatedFrom: "",
  redBorder: false,
  inValidUser: "",
  options: [],
  userValidateError: false,
  otherppError: false,
  alterLoc: [{}],
  stateWiseData: {},
  displayCabinetMilestones: false,
  cabinetBucketIds: [1, 8],
  ZIndex: 1
});

export const addIssuePayload = () => ({
  fileManagerList: [],
  groupCategory: "",
  issueCategoryId: null,
  issueDescription: "",
  recipientGroup: null,
  title: ""
});

export const fdiPattern = /(^(^([2-9]?[0-9]{1}))|^(1?0?0))/gi;
export const mandatoryFieldsOfAddIssue = [
  "groupCategory",
  "issueCategoryId",
  "issueDescription",
  "recipientGroup",
  "title"
];

export const PROJECT_STATUS = {
  UV: "UNDER_VERIFICATION",
  VERIFIED: "VERIFIED",
  DRAFT: "DRAFT",
  EDIT_MILESTONE: "EDIT_MILESTONE",
  DRAFT_MILESTONE: "DRAFT_MILESTONE"
};

export const STATUS_HELPER = {
  UNDER_VERIFICATION: [],
  UV: []
};

export const getSelectedOptionImage = (value, options = []) => {
  let selectedOption = options.find(item => item.id === +value);
  return selectedOption && selectedOption.imageUrl;
};

export const getSelectedStatePmgConstituted = (value, options = []) => {
  let selectedOption = options.find(item => item.id === +value);
  return selectedOption && selectedOption.statePmgConstituted;
};

export const getSelectedStateMinimumCost = (value, options = []) => {
  let selectedOption = options.find(item => item.id === +value);
  return selectedOption && selectedOption.stateMinimumCost;
};

export const getSelectedStateProjectName = (value, options = []) => {
  let selectedOption = options.find(item => item.id === +value);
  return selectedOption && selectedOption.projectFormDTO.projectName;
};

export const PROJECT_CLASSIFICATION = {
  BROWN_FIELD: "BROWN FIELD",
  GREEN_FIELD: "GREEN FIELD"
};

export const setIncomingDataForMilestone = (data, userID, projectPPList) => {
  let arr = [];
  const userInfo = getLocalstorage("user");
  data &&
    data.length &&
    data.map(item => {
      let bucketDetail = item.bucket;
      let milestonesDetail = item.milestones;
      let milestoneDataCOS = [];

      milestonesDetail &&
        milestonesDetail.length &&
        milestonesDetail.map(milestone => {
          let obj = {
            completed: false,
            disabled: false,
            milestone: {
              id: milestone.id,
              name: milestone.name,
              predefined: milestone.predefined
            }
          };
          milestoneDataCOS.push(obj);
        });

      let obj = {
        bucketId: get(bucketDetail, "id"),
        bucketName: get(bucketDetail, "name"),
        bucketType: get(bucketDetail, "bucketType"),
        completed: false,
        disabled: false,
        milestoneTableDataCOS: [
          {
            milestoneDataCOS: milestoneDataCOS,
            phaseProponentId:
              (!!userID && userID.id) ||
              (Array.isArray(projectPPList) &&
                !!projectPPList[0] &&
                get(projectPPList[0], "id", null)) ||
              get(userInfo, "id", null),
            phaseProponent: {
              id:
                (!!userID && userID.id) ||
                (Array.isArray(projectPPList) &&
                  !!projectPPList[0] &&
                  get(projectPPList[0], "id", null)) ||
                get(userInfo, "id", null),
              name:
                (!!userID && userID.name) ||
                (Array.isArray(projectPPList) &&
                  !!projectPPList[0] &&
                  get(projectPPList[0], "name", null)) ||
                get(userInfo, "name", null)
            },
            milestoneTable: {
              name: "Phase (I)"
            },
            tableIndex: 0
          }
        ]
      };

      arr.push(obj);
    });

  return arr;
};

export const editMilestoneDependency = (data, projectPPList) => {
  data &&
    data.length &&
    data.map(_bucket => {
      _bucket.milestoneTableDataCOS.map(_table => {
        _table.phaseProponentId =
          get(_table, "phaseProponent.id", null) ||
          get(projectPPList[0], "id", null);
        _table.phaseProponent = {
          id:
            get(_table, "phaseProponent.id", null) ||
            get(projectPPList[0], "id", null),
          name:
            get(_table, "phaseProponent.name", null) ||
            get(projectPPList[0], "name", null)
        };
        _table.milestoneDataCOS.map(item => {
          let isDependencyExists = _table.milestoneDataCOS.find(
            checkMS =>
              checkMS.disabled === true &&
              checkMS.milestone.id == item.dependentOnId
          );
          if (!!isDependencyExists) {
            item.dependentOnId = null;
            item.dependentOnName = null;
            item.dependentOn = null;
          }
        });
      });
    });
  return data;
};

export const setDraftDataForMilestone = data => {
  let arr = [];
  data &&
    data.length &&
    data.map(item => {
      let bucketDetail = item.bucket;
      let milestonesDetail = item.milestoneTableDataList;

      milestonesDetail &&
        milestonesDetail.length &&
        milestonesDetail.map(milestone => {
          let _milestoneDataList = milestone ? milestone.milestoneDataList : [];
          milestone.phaseProponentId = get(
            milestone,
            "phaseProponent.id",
            null
          );

          _milestoneDataList &&
            _milestoneDataList.length &&
            _milestoneDataList.map(_milestoneDataListItem => {
              _milestoneDataListItem.dependentOnId = get(
                _milestoneDataListItem,
                "dependentOn.id"
              );
              _milestoneDataListItem.dependentOnName = get(
                _milestoneDataListItem,
                "dependentOn.name"
              );
              _milestoneDataListItem.responsibleAuthorityId = get(
                _milestoneDataListItem,
                "responsibleAuthority.id"
              );
              _milestoneDataListItem.responsibleAuthorityName = get(
                _milestoneDataListItem,
                "responsibleAuthority.name"
              );
              return _milestoneDataListItem;
            });
          milestone.milestoneTable = milestone.table;
          milestone.milestoneDataCOS = _milestoneDataList || [];
          /*delete milestone.table;
          delete milestone.milestoneDataList;*/
          return milestone;
        });

      let obj = {
        bucketId: get(bucketDetail, "id"),
        bucketName: get(bucketDetail, "name"),
        bucketType: get(bucketDetail, "bucketType"),
        bucketStatusDTO: get(item, "bucketStatusDTO"),
        bucketDelayReason: get(item, "bucketDelayReason"),
        completed: get(item, "completed"),
        disabled: get(item, "disabled"),
        disableReason: get(item, "disableReason"),
        milestoneTableDataCOS: milestonesDetail,
        originalScheduledFinishDate: get(item, "originalScheduledFinishDate"),
        originalScheduledStartDate: get(item, "originalScheduledStartDate"),
        revisedCost: get(item, "revisedCost"),
        originalCost: get(item, "originalCost"),
        revisedArea: get(item, "revisedArea"),
        originalArea: get(item, "originalArea"),
        revisedScheduledFinishDate: get(item, "revisedScheduledFinishDate"),
        revisedScheduledStartDate: get(item, "revisedScheduledStartDate")
      };

      arr.push(obj);
    });

  return arr;
};

export const setOutgoingDataForMilestone = bucketMilestoneCOS => {
  return (
    bucketMilestoneCOS &&
    bucketMilestoneCOS.length &&
    bucketMilestoneCOS.map(bucket => {
      bucket.milestoneTableDataCOS.map(data => {
        data.milestoneDataCOS = data.milestoneDataCOS.filter(
          item => item !== undefined
        );
        if (data.milestoneDataList) {
          data.milestoneDataList =
            data.milestoneDataList.length &&
            data.milestoneDataList.filter(item => item !== undefined);
        }
        return data;
      });
      if (bucket.disabled) bucket.milestoneTableDataCOS = [];
      return bucket;
    })
  );
};

export function modifyDataForIIGDraftProject(data) {
  const userInfo = getLocalstorage("user");
  const isStatePMG = userInfo.groupCategory === "STATE_PMG";
  const isStateDepartment = userInfo.groupCategory === "STATE_DEPARTMENT";
  return {
    bucketMilestoneCOS: [],
    sponsoringDepartmentId:
      get(data, "sponsoringDepartment") !== null
        ? +get(data, "sponsoringDepartment.id")
        : null,
    updatedCreatedById: {},
    showModalForVerifyingProject: false,
    comment: "",
    showModalForRejectingProject: false,
    updatedCreatedById: get(data, "previousCreatedBy"),
    projectCategoryId: get(data, "projectCategory"),
    groupCategoryList: get(data, "sponsoredBy", []),
    originalSponsoredById: get(data, "sponsoredBy.id"), // original group id contains the data from API. It does not get changed on sponsoring ministry change.
    originalLocations: get(data, "locations", []).map(value => {
      return {
        id: value.stateId,
        name: value.state,
        distance: value.distance,
        cost: value.cost,
        districtId: value.districtIdName.map(district => district.id) || [],
        districtList: value.districtList,
        districtIdName: value.districtIdName || []
      };
    }),
    groupId: get(data, "sponsoredBy.id"),
    displayId: get(data, "displayId"),
    sectorId: get(data, "sector.id"),
    subSectorId: +get(data, "subSector.id") || null,
    locations: get(data, "locations", []).map(value => {
      return {
        id: value.stateId,
        name: value.state,
        distance: value.distance,
        cost: value.cost,
        districtId: value.districtIdName.map(district => district.id) || [],
        districtList: value.districtList,
        districtIdName: value.districtIdName || [],
        circleId: value.circleIdName.map(circle => circle.id) || [],
        circleList: value.circleList,
        circleIdName: value.circleIdName || []
      };
    }),
    edit: get(data, "edit"),
    status: get(data, "status"),
    projectCategory: get(data, "projectCategory"),
    projectId: get(data, "id"),
    name: htmlToFormattedText(get(data, "name")),
    description: htmlToFormattedText(get(data, "description")),
    createdDate: get(data, "createdDate"),
    cin: htmlToFormattedText(get(data, "cin.number")),
    sector: get(data, "sector.name"),
    cost: get(data, "cost"),
    revisedCost: get(data, "revisedCost"),
    implementationMode: get(data, "implMode"),
    projectImplementationClassification: get(data, "classfication"),
    nipReview: get(data, "nipDTO.nipReview"),
    nipReviewDate: get(data, "nipDTO.nipReviewDate"),
    pmFoundationStone: get(data, "pmFoundationStoneDTO.pmFoundationStone"),
    pmFoundationStoneId: get(data, "pmFoundationStoneDTO.pmFoundationStoneId"),
    pmFoundationStoneDate: get(
      data,
      "pmFoundationStoneDTO.pmFoundationStoneDate"
    ),
    pmgsHip: get(data, " pmGsHipDTO. pmgsHip"),
    pmgsHipDate: get(data, "pmgsHipDateDTO.pmgsHipDate"),
    cmPragatiYatra: get(data, "cmPragatiYatraDTO.cmPragatiYatra"),
    cmPragatiYatraDate: get(data, "cmPragatiYatraDTO.cmPragatiYatraDate"),
    cmFoundationStone: get(data, "cmFoundationStoneDTO.cmFoundationStone"),
    cmFoundationStoneDate: get(
      data,
      "cmFoundationStoneDTO.cmFoundationStoneDate"
    ),
    pragatiReview: get(data, "pragatiDTO.pragatiReview"),
    pragatiReviewDates: get(data, "pragatiDTO.pragatiReviewDates[0]"),
    pragatiPipeline: get(data, "pragatiDTO.pragatiPipeline"),
    pragatiCycleDate: get(data, "pragatiDTO.pragatiCycleDate"),
    finClosureDate: get(data, "finClosureDate"),
    finClosureExpDate: get(data, "finClosureExpDate"),
    projectImplementationStartState: get(data, "implementationStarted"),
    projectImplementationStartDate: get(data, "implementationStartDate"),
    projectImplementationSanctionDate: get(data, "projectSanctionDate"),
    projectImplementationSecretaryReviewDate: get(data, "secretaryReviewDates"),
    projectImplementationAnticipatedDate: get(
      data,
      "anticipatedDateOfCompletion"
    ),
    projectStage: get(data, "iigPayload.projectStage"),
    projectStatus: get(data, "iigPayload.projectStatus"),
    iigPayload: get(data, "iigPayload"),
    iigMappingdetails: get(data, "iigMappingdetails"),
    implMode: get(data, "implMode"),
    iigProjectReferenceId: get(data, "iigProjectReferenceId"),
    iigProjectCommonId: get(data, "commonId"),
    iigProjectStatus: get(data, "iigProjectStatus"),
    projectCompletionDTO: get(data, "projectCompletionDTO"),
    projectBankInfoActualDate: get(data, "finClosureDate"),
    projectBankInfoExpectedDate: get(data, "finClosureExpDate"),
    projectImplementationDirectEmployment: get(
      data,
      "iigPayload.directEmployment"
    ),
    projectImplementationInDirectEmployment: get(
      data,
      "iigPayload.indirectEmployment"
    ),
    //  defaultSelected:
    //   isStatePMG || isStateDepartment
    //     ? `${get(data, "statePreviousCreatedBy.name")} (${get(
    //         data,
    //         "statePreviousCreatedBy.organization"
    //       )})`
    //     : `${get(data, "previousCreatedBy.name")} (${get(
    //         data,
    //         "previousCreatedBy.userID"
    //       )})`,
    defaultSelected: get(data, "previousCreatedBy.name"),
    userID: get(data, "previousCreatedBy.id"),
    revisedTargetCompletionDate: get(data, "revisedTargetCompletionDate"),
    error: {
      defaultSelected: {
        error: !get(data, "previousCreatedBy.name")
      },
      projectCategoryId: { error: !get(data, "projectCategory") },
      name: { error: !get(data, "name") },
      groupId: { error: !get(data, "sponsoredBy.id") },
      cost: {
        error:
          get(data, "sponsoredBy.id") !== 226 &&
          !get(data, "superAdmin") &&
          !get(data, "cost")
      },
      description: { error: !get(data, "description") },
      implementationMode: { error: !get(data, "implMode") },
      locations: [
        { error: !(get(data, "locations") && get(data, "locations").length) }
      ],
      projectImplementationClassification: {
        error: !get(data, "classfication")
      },
      sectorId: { error: !get(data, "sector.id") },
      subSectorId: { error: !get(data, "subSector.id") },
      projectImplementationStartState: {
        error: !get(data, "implementationStarted")
      },
      projectCompletionDTO: {
        error:
          get(data, "implementationStarted") !== "COMPLETED" &&
          !get(data, "projectCompletionDTO")
      },
      otherBankName: { error: !get(data, "otherBankName") },
      projectImplementationAnticipatedDate: {
        error: !get(data, "anticipatedDateOfCompletion")
      },
      projectImplementationStartDate: {
        error: !get(data, "implementationStartDate")
      },
      projectImplementationSanctionDate: {
        error: !get(data, "projectSanctionDate")
      },
      revisedCost: { error: false },
      nipReview: { error: !get(data, "nipDTO.nipReview") },
      nipReviewDate: { error: !get(data, "nipDTO.nipReviewDate") },
      pragatiCycleDate: { error: !get(data, "pragatiDTO.pragatiCycleDate") }
    },
    isApiLoading: false,
    districtList: [],
    circleList: [],
    toggleAttachmentDisplay: false,
    files: get(data, "documents", []),
    mapImageFiles: get(data, "mapImageFiles", []),
    isIIGProjectEdit:
      data.hasOwnProperty("iigPayload") &&
      data.iigPayload !== null &&
      get(data, "edit", false)
  };
}
